import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'What Can I Ship with ShipSticks?',
  description:
    'From drivers to duffels, ShipSticks makes sending your gear to and from ' +
    'home easy, so you can travel lighter and skip the airport stress.',
  alternates: {
    canonical: 'https://www.shipsticks.com/what-can-i-ship',
  },
}

export default metadata
